import {BoardContainer, TitleContainer} from "../../assets/GlobalStyles";
import React from "react";
import {Link, useParams} from "react-router-dom";
import DashBoardIndex from "./DashBoardIndex";
import styled from "styled-components";

export default function DashBoard(){
  const params = useParams()
  return(
    <main>
      <BoardContainer>
        <TitleContainer>
          <DashboardTitleArea>
            <h1>광고주 및 캠페인 현황</h1>
            <DashboardDescription>
              광고주와 캠페인의 주요 성과와 지표를 한눈에 확인할 수 있습니다.
            </DashboardDescription>
          </DashboardTitleArea>
          <CreateCampaignButton to="/board/campaign">
            <span aria-hidden="true">＋</span>
            캠페인 생성
          </CreateCampaignButton>
        </TitleContainer>
        {params.id === 'dashboard' && <DashBoardIndex/>}
      </BoardContainer>
    </main>
  )
}

const DashboardTitleArea = styled.div`
  min-width: 0;
`;

const DashboardDescription = styled.p`
  margin: 8px 0 0;
  color: #858d95;
  font-size: var(--font-size-13);
  line-height: 1.5;
`;

const CreateCampaignButton = styled(Link)`
  display: inline-flex;
  min-width: 112px;
  height: 38px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding: 0 15px;
  border: 1px solid #f5811f;
  border-radius: 7px;
  background: #f5811f;
  box-shadow: 0 5px 14px rgba(245, 129, 31, .18);
  color: #fff;
  font-size: var(--font-size-13);
  font-weight: 700;
  text-decoration: none;

  &:hover { background: #e97312; }

  @media (max-width: 560px) {
    min-width: 94px;
    padding: 0 10px;
  }
`;
